export default function MiniHeader() {

  return (
    <div className="flex justify-between items-center relative">
      {/* Left Title */}
      <h2 className="text-[var(--text)] text-sm font-semibold mb-1">
        Trade
      </h2>
    </div>
  );
}
